import { userPermissionsList } from "../actions/admin";

/**
 * Utils for working with permissions
 */
class PermissionsUtils {
    /**
     *
     * @param {Array} items
     * @param {Array} permissions_list
     * @return {Array}
     */
    static allowedSidebarItems(items, permissions_list) {
        // if permission is needed for this set of items
        if ("permission" in items[0]) {
            const allowed = [];
            items.forEach((item) => {
                const has_child = Object.keys(item).includes("subItems");
                if (["secondary", "devider"].includes(item.type)) {
                    allowed.push(item);
                } else {
                    if (typeof item.permission === "object") {
                        if (Array.isArray(item.permission)) {
                            let has_permission = true;
                            item.permission.forEach((per) => {
                                if (!permissions_list.includes(per)) {
                                    has_permission = false;
                                    return;
                                }
                            });

                            if (has_permission) {
                                if (has_child) {
                                    item.subItems = this.allowedSidebarItems(
                                        item.subItems,
                                        permissions_list
                                    );
                                    allowed.push(item);
                                } else {
                                    allowed.push(item);
                                }
                            }
                        } else {
                            const keys = Object.keys(item.permission);
                            if (keys.length > 0) {
                                const all = keys.includes("all") ?
                                    item.permission.all :
                                    [];
                                const one = keys.includes("one") ?
                                    item.permission.one :
                                    [];

                                let has_all = true;
                                let has_one = false;

                                all.forEach((per) => {
                                    if (!permissions_list.includes(per)) {
                                        has_all = false;
                                        return;
                                    }
                                });

                                one.forEach((per) => {
                                    if (permissions_list.includes(per)) {
                                        has_one = true;
                                        return;
                                    }
                                });

                                if (has_one && has_all) {
                                    if (has_child) {
                                        item.subItems =
                                            this.allowedSidebarItems(
                                                item.subItems,
                                                permissions_list
                                            );
                                        allowed.push(item);
                                    } else {
                                        allowed.push(item);
                                    }
                                }
                            } else {
                                if (has_child) {
                                    item.subItems = this.allowedSidebarItems(
                                        item.subItems,
                                        permissions_list
                                    );
                                    allowed.push(item);
                                } else {
                                    allowed.push(item);
                                }
                            }
                        }
                    } else if (typeof item.permission === "string") {
                        if (permissions_list.includes(item.permission)) {
                            if (has_child) {
                                item.subItems = this.allowedSidebarItems(
                                    item.subItems,
                                    permissions_list
                                );
                                allowed.push(item);
                            } else {
                                allowed.push(item);
                            }
                        }
                    } else {
                        if (has_child) {
                            item.subItems = this.allowedSidebarItems(
                                item.subItems,
                                permissions_list
                            );
                            allowed.push(item);
                        } else {
                            allowed.push(item);
                        }
                    }
                }
            });
            return allowed;
        } else {
            return items;
        }
    }

    /**
     * check current user has specific permission
     * @param {string} permisssion_name
     * @return {boolean}
     */
    static hasPermission = function(permisssion_name) {
        const permissions = sessionStorage.getItem("CUP");

        if (permissions) {
            const list = JSON.parse(permissions);
            return list.includes(permisssion_name);
        } else {
            userPermissionsList().then((response) => {
                const list = response.permissions;
                sessionStorage.setItem("CUP", JSON.stringify(list));

                return list.includes(permisssion_name);
            });
        }
    };

    /**
     * get and return permissions from server and save them in local storage
     *
     * @return {Promise<{}>}
     */
    static loadPermissions() {
        return userPermissionsList().then((response) => {
            const list = response.permissions;
            sessionStorage.setItem("CUP", JSON.stringify(list));

            return Promise.resolve({
                permissions: list,
            });
        });
    }
}

const _p = PermissionsUtils.hasPermission;

export { PermissionsUtils, _p };
export default PermissionsUtils;
